import { useSelector } from 'react-redux';
import {
  Checkbox,
  CheckboxGroup,
  Column,
  FormField,
  Row,
  Tooltip,
} from '@tempmee/react';
import { OutlineInformationCircleIcon, SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { CollapsibleCard } from '../../../../commonComponents';
import { useFormContext } from '../../hooks/useFormContext';
import { CardTitle } from '../CardTitle';
import { useInsuranceProvider } from './hooks/useInsuranceProvider';

export const InsuranceProviderCard = ({ isOpen, onToggle }) => {
  const { setValue, control } = useFormContext();
  const { formValues, isValid } = useInsuranceProvider(control);
  const officeEducation = useSelector((state) => state.user.officeEducation);

  const handleChange = (updatedValues) => {
    setValue('insurances', [...updatedValues].sort());
  };

  return (
    <CollapsibleCard
      TitleComponent={() => (
        <CardTitle name="Insurance Provider" showWarningIcon={!isOpen && !isValid} />
      )}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <Column gap={5} px={20} style={{ marginBottom: 40 }}>
        <FormField
          label="What insurance provider does your office use?"
          TrailingComponent={
            <Row gap={1} align="center">
              <Tooltip content="GoTu now allows you to post temp shifts looking for a Associate Dentist. To be able to post those shifts, you will be required to indicate what insurance your office is covered under. This is to help us find Associate Dentists who are covered under the same insurance as your office.">
                <OutlineInformationCircleIcon
                  width={20}
                  height={20}
                  color={colors.neutral['300']}
                  style={{ cursor: 'pointer' }}
                />
              </Tooltip>
              {!isValid && (
                <SolidExclamationWarningAlertIcon
                  width={16}
                  height={16}
                  color={colors.warning['500']}
                />
              )}
            </Row>
          }
        >
          <CheckboxGroup value={formValues.insurances} onChange={handleChange}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 15 }}>
              {officeEducation?.insurances?.map((name) => (
                <Checkbox key={name} value={name} label={name} />
              ))}
            </div>
          </CheckboxGroup>
        </FormField>
      </Column>
    </CollapsibleCard>
  );
};
